"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosClient = exports.standardHeaders = exports.throwHttpError = void 0;
const axios_1 = __importStar(require("axios"));
const configs_1 = require("../configs");
const navigation_1 = __importDefault(require("@App/navigation"));
const HttpError_1 = require("@App/exceptions/HttpError");
const qs_1 = __importDefault(require("qs"));
// HttpError helper method, this will most likely want to be revisited at some point
const throwHttpError = (res) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (res.data) {
        // apparently we have two different error objects that are returned, this case covers the one I just found
        if (res.data.title) {
            throw new HttpError_1.HttpError(res.data.title, res.data.status);
        }
        else {
            const errorMessageObject = res.data;
            throw new HttpError_1.HttpError(errorMessageObject.message, res.status);
        }
    }
    else if ((0, axios_1.isAxiosError)(res)) {
        throw new HttpError_1.HttpError(res.message, (_a = res.code) !== null && _a !== void 0 ? _a : 0);
    }
    else {
        throw new HttpError_1.HttpError(res.statusText, res.status);
    }
});
exports.throwHttpError = throwHttpError;
exports.standardHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
};
exports.axiosClient = axios_1.default.create({
    baseURL: configs_1.configuration.api,
    headers: exports.standardHeaders,
    paramsSerializer: {
        serialize: (params) => qs_1.default.stringify(params, { arrayFormat: 'comma' }),
    },
});
exports.axiosClient.interceptors.response.use((response) => response, (error) => {
    const res = error.response;
    switch (res === null || res === void 0 ? void 0 : res.status) {
        case 503:
            // Just pass through 503s - these are handled by another interceptor
            return Promise.reject(error);
        case 401:
            if (!(error.config.url.endsWith('/token') || error.config.url.endsWith('/mfa-confirm'))) {
                window.location.href = navigation_1.default.login.handleInactive();
            }
            break;
        case 404:
            if (window.location.pathname.split('/').pop() !== 'view') {
                window.location.href = '/';
                break;
            }
            else {
                return (0, exports.throwHttpError)(res);
            }
        case 403:
            window.location.href = navigation_1.default.accessDenied.root();
            break;
    }
    return (0, exports.throwHttpError)(res !== null && res !== void 0 ? res : error);
});
exports.default = {
    axiosClient: exports.axiosClient,
};
